import { hasPermission } from "@/utils/auth";
import { requireMainPermission } from "./permission";
import { createRouter, createWebHashHistory } from "vue-router";
import type { RouteRecordRaw, RouteLocationNormalized } from "vue-router";
import route_config from "./config";
export type AddRouteRecordRaw = RouteRecordRaw & {
  hidden?: boolean;
};

const routes: Array<AddRouteRecordRaw> = [
  {
    path: "/",
    name: "main",
    redirect: "/home",
    meta: {
      is_meun: true
    },
    beforeEnter: requireMainPermission,
    component: () => import("@/pages/main/index.vue"),
    children: [...route_config]
  },
  {
    name: "login",
    path: "/login",
    component: () => import("@/pages/login/index.vue")
  },
  {
    name: "filePreview",
    path: "/filePreview",
    component: () => import("@/pages/preview/index.vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("@/pages/notError/404.vue")
  },

  {
    name: "401",
    path: "/401",
    component: () => import("@/pages/notError/401.vue")
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes as AddRouteRecordRaw[],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
});

// 权限校验，无权限直接去404
router.beforeEach(
  (to: RouteLocationNormalized, _from: RouteLocationNormalized, next) => {
    if (to.meta && to.meta.roles) {
      const roles: string[] = to.meta.roles as string[];
      if (hasPermission(roles)) {
        return next();
      } else {
        return next({
          path: "/401"
        });
      }
    }
    next();
  }
);
export { routes };
export default router;
